
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { AuthService } from '../services/auth-service';
import { State, Action, Getter } from 'vuex-class';
import { ProfileState, User } from 'src/store/models/ProfileModel';
import BasicHelpDialog from '@/components/BasicHelpDialog.vue';
import axios, { AxiosError } from 'axios';

const namespace: string = 'profile';

@Component({
  components: { BasicHelpDialog }
})
export default class LoginComponent extends Vue {
  $refs!: {
    helpDeskDialog: HTMLFormElement;
  };
  @Getter('isAuthenticated', { namespace })
  isAuthenticated!: boolean;
  @Action('login', { namespace })
  login: any;
  @Action('GetItemInfo', { namespace: 'items' })
  getItemInfo: any;
  @Action('getCurrentCustomer', { namespace: 'customer' })
  getCurrentCustomerStore: any;
  UserName: string = '';
  Password: string = '';
  hasLoginError: boolean = false;
  userNameAutofilled: boolean = false;
  passwordAutofilled: boolean = false;
  shouldShowPassword: boolean = false;
  errorMsg: string = '';
  didAcceptTerms: boolean = false;
  canLogin: boolean = false;
  isConfirmed: boolean = false;

  EmailRules: any[] = [
    (v: any) => !!v || 'E-mail is required',
    (v: any) => /.+@.+\..+/.test(v) || v == 'admin' || 'E-mail must be valid'
  ];
  isLoggingIn: boolean = false;
  goToSignUp(): void {
    this.$router.push('/Register');
  }
  goTo(path: string): void {
    this.$router.push(path);
  }
  goToPasswordReset() {
    window.open(`${process.env.VUE_APP_J1L_URL}/passwordreset`);
  }
  goToJ1L() {
    window.location.href = `${process.env.VUE_APP_J1L_URL}/login`;
  }
  openHelpDesk() {
    this.$refs.helpDeskDialog.openDialog();
  }
  goToPrivacy() {
    this.$router.push({
      name: 'Privacy'
    });
  }
  loginUser() {
    if (!this.canLogin || !this.didAcceptTerms) return;
    this.isLoggingIn = true;
    this.hasLoginError = false;
    const formData: any = new FormData();
    formData.set('userName', this.UserName);
    formData.set('Password', this.Password);
    this.login(formData)
      .then(() => {
        this.isLoggingIn = false;
        this.getCurrentCustomerStore();
        this.getItemInfo();
        this.$router.push('/items').catch();
      })
      .catch((err: AxiosError) => {
        if (err.response?.status === 400) {
          this.errorMsg = err.response.data.message;
        }
        this.hasLoginError = true;
        this.isLoggingIn = false;
      });
  }
  @Watch('isAuthenticated')
  onPropertyChanged(areThey: boolean, oldValue: boolean) {
    if (areThey) {
      const currentHost = window.location.host;
      const newSubdomain = process.env.VUE_APP_SUBDOMAIN_REDIRECT;

      if (!newSubdomain) {
        console.error('New subdomain not set in environment variables');
        return;
      }

      if (this.$route.params.nextUrl && this.$route.params.nextUrl !== '/items') {
        const newUrl = `https://${newSubdomain}.${currentHost
          .split('.')
          .slice(1)
          .join('.')}${this.$route.params.nextUrl}`;
        window.location.href = newUrl;
      } else {
        const newUrl = `https://${newSubdomain}.${currentHost
          .split('.')
          .slice(1)
          .join('.')}/items`;
        window.location.href = newUrl;
      }
    }
  }
  @Watch('UserName')
  onUserNameAutoFill(val: string) {
    if (val) this.userNameAutofilled = true;
    else this.userNameAutofilled = false;
  }
  @Watch('Password')
  onUPasswordAutoFill(val: string) {
    if (val) this.passwordAutofilled = true;
    else this.passwordAutofilled = false;
  }
  mounted() {
    // if (this.$route.params.confirmed) this.isConfirmed = true;
    const newSubdomain = process.env.VUE_APP_MAIN_SITE;

    if (!newSubdomain) {
      console.error('New subdomain not set in environment variables');
      return;
    }
    const newUrl = `${newSubdomain}/login`;
    window.location.href = newUrl;
  }
}
